// Deep links into the manager dashboard's Mechanical tab.
//
// Preview links carry ?buildingId=<Building.buildingId>&preview=1 which
// previewSession.js turns into a tab-scoped manager impersonation (only
// works for someone already logged in as a maintenance user). Manager
// links omit those params — the manager's own login supplies the
// building — so they can be texted/emailed straight to the manager.
//
// NOTE: buildingId here is the string Building.buildingId field (what
// manage-accounts and the manager APIs use), NOT the Parse objectId the
// tech schedule routes use. Issue/visit/equipment ids are objectIds.

export function managerPreviewUrl(buildingIdStr, extraParams = {}) {
  const params = new URLSearchParams({ buildingId: buildingIdStr, preview: '1', ...extraParams });
  return `${window.location.origin}/mechanical-room?${params.toString()}`;
}

export function managerEquipmentPreviewUrl(buildingIdStr, equipmentId) {
  const params = new URLSearchParams({ buildingId: buildingIdStr, preview: '1' });
  return `${window.location.origin}/mechanical-room/equipment/${encodeURIComponent(equipmentId)}?${params.toString()}`;
}

export function managerIssueLink(issueId) {
  return `${window.location.origin}/mechanical-room?issue=${encodeURIComponent(issueId)}`;
}

export function managerVisitLink(visitId) {
  return `${window.location.origin}/mechanical-room?service=${encodeURIComponent(visitId)}`;
}

export async function copyToClipboard(text) {
  try {
    await navigator.clipboard.writeText(text);
  } catch {
    // Clipboard API blocked (e.g. non-HTTPS) — fall back to a hidden textarea.
    const ta = document.createElement('textarea');
    ta.value = text;
    document.body.appendChild(ta);
    ta.select();
    document.execCommand('copy');
    document.body.removeChild(ta);
  }
}
